'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _constants = require('../constants');

function enableDebug() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    if (global.analytics) {
        if (global.analytics.debug) {
            if (key) {
                global.analytics.debug();
            } else {
                global.analytics.debug(false);
            }
        } else {
            console.warn(_constants.MESSAGE_ERROR_NO_ANALYTICS_DEBUG);
        }
    } else {
        console.warn(_constants.MESSAGE_ERROR_NO_ANALYTICS);
    }
}

exports.default = enableDebug;


//////////////////
// WEBPACK FOOTER
// ./~/rp-betting-special-offer/~/rp-analytics/lib/utils/enableDebug.js
// module id = 2638
// module chunks = 0